import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { GetUserTokenType } from '../../domains/valueObject/SwitchUserProgressResponses';
import { MailingUser } from './MailingUser';
import { getUrlToLoginViaToken } from '../getUrlToLoginViaToken';
import { getHubApi } from '../../general/modules/accountServiceApi/getAccountServiceApi';

export class MailingLogin {
    private mailingUser: MailingUser;

    constructor(mailingUser: MailingUser) {
        this.mailingUser = mailingUser;
    }

    public async auth(): Promise<void> {
        try {
            const hubApi = getHubApi();
            const hubResponse: GetUserTokenType = await hubApi.getTokenByMailingToken(this.mailingUser.getDeviceId(), {
                locale: this.mailingUser.getLocale(),
                entryPoint: this.mailingUser.getEntryPoint(),
                mailingToken: this.mailingUser.getMailingToken(),
                suid: this.mailingUser.getSuid(),
                generatedAt: this.mailingUser.getGeneratedAt()
            });

            let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
            url = addLoginQueryParams(url);
            appendUnityLoginIframe(url);
        } catch (exception) {
            window.Sentry.captureException(`Got exception on mailing login ${JSON.stringify(exception)}`);
        }
    }
}
